module.exports = __webpack_public_path__ + "static/zip-icon-real-540db22c75278f96206bd5e68e609e5d.png";